module.exports = __webpack_public_path__ + "static/media/btn-paquetes.76cfcc93.png";